import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import isApp from "shared/util/isApp";
import classnames from "classnames";

import "./Buttons.scss";

if (process.env.PLATFORM === "desktop") {
	require("./Buttons.desktop.scss");
}

const Buttons = ({
	onSkip,
	onSubmit,
	canSubmit,
	targetAnswerMode,
	targetAnswerModeOnCancel,
	isProcessing,
}) => {
	const saveText = targetAnswerMode && process.env.PLATFORM === "mobile" ?
		_str("Save answer") :
		_str("Save");

	const showCancelButton = targetAnswerMode &&
		targetAnswerModeOnCancel &&
		(process.env.PLATFORM === "desktop" || isApp());

	return (
		<div className="questionspage-buttons">
			{!targetAnswerMode &&
				<button
					className={classnames({
						"questionspage-buttons-button": true,
						"questionspage-buttons-button--skip": true,
						"flatbutton white": true,
					})}
					onClick={onSkip}
				>
					<Str>Skip</Str>
				</button>
			}

			{showCancelButton &&
				<button
					className={classnames({
						"questionspage-buttons-button": true,
						"questionspage-buttons-button--skip": true,
						"flatbutton white": true,
					})}
					onClick={targetAnswerModeOnCancel}
				>
					<Str>Cancel</Str>
				</button>
			}

			<button
				className={classnames({
					"questionspage-buttons-button": true,
					"questionspage-buttons-button--answer": true,
					"flatbutton blue": true,
					"disabled": !canSubmit,
				})}
				onClick={onSubmit}
				disabled={!canSubmit}
			>
				{isProcessing &&
					<Str>Saving…</Str>
				}
				{!isProcessing &&
					<Fragment>{saveText}</Fragment>
				}
			</button>
		</div>
	);
};

Buttons.propTypes = {
	onSkip: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
	canSubmit: PropTypes.bool.isRequired,
	targetAnswerMode: PropTypes.bool.isRequired,
	isProcessing: PropTypes.bool,
	targetAnswerModeOnCancel: PropTypes.func,
};

Buttons.defaultProps = {
	isProcessing: false,
	targetAnswerModeOnCancel: null,
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/apps/questions/components/MultiPartQuestionWrapper/Buttons.jsx